module.exports = __webpack_public_path__ + "media/images/emblems/Saviese-coat_of_arms-a95599dc3c329dd5f57818dd398b3869.svg";